import { render } from "./ResultItemCardChild.vue?vue&type=template&id=2d118bfd&scoped=true"
import script from "./ResultItemCardChild.vue?vue&type=script&lang=js"
export * from "./ResultItemCardChild.vue?vue&type=script&lang=js"

import "./ResultItemCardChild.vue?vue&type=style&index=0&id=2d118bfd&scoped=true&lang=scss"

import exportComponent from "/home/devops/tool_cases/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d118bfd"]])

export default __exports__